import { Card, CardBody, CardHeader, CardTitle, Col, Container, Row } from "reactstrap";
import { TWorkSession } from "../../../../common/types";
import InfoField from "../../../../components/Common/InfoField";
import { ReadOnlyMap } from "../../../../components/Common";
import { TGeometry, TNullable } from "../../../../common/types/common";
import WorkSessionDetails from "../../../../components/Common/workSessionDetails";
import OperatorField from "../operator-field";
import { OperatorFormValues } from "../operator-form";
import { JobFormValues } from "../job-form";
import JobField from "../job-field";
import Tabs from "../tabs";
import { useWorkSessionGeometry } from "src/common/hooks/api/work-sessions";
import { useState } from "react";

interface Props {
    data?: TNullable<TWorkSession>;
    onAssignOperator: (_form: OperatorFormValues) => void;
    onAssignJob: (_form: JobFormValues) => void;
}

const WorkSessionDetailsContainer = ({ data, onAssignOperator, onAssignJob }: Props) => {
    const [jobGeometry, setJobGeometry] = useState<TGeometry | undefined>(undefined);
    const [pathGeometry, setPathGeometry] = useState<TGeometry | null>(null);
    const [acresCleared, setAcresCleared] = useState<number | string>('-');

    const { data: workSessionGeometry } = useWorkSessionGeometry(data?.id, {
        enabled: !!data?.id,
        onSuccess: () => {
            const jobRings: number[][][] = workSessionGeometry?.data?.jobGeometry?.rings.map(ring => ring.map(point => [point[0], point[1]]));
            setJobGeometry({rings: jobRings, spatialReference: {wkid: workSessionGeometry?.data?.jobGeometry?.spatialReference.wkid}});
            const path: number[][] = workSessionGeometry?.data?.gpsData.map(data => [data.longitude, data.latitude]);
            setAcresCleared(workSessionGeometry?.data?.acresCleared.toFixed(2));
            setPathGeometry({rings: [path], spatialReference: {wkid: 4326}});
        },
    });

    return (
        <Container fluid className="work-session-details mt-4">
            <Row className="pb-4">
                <Col xl={9} sx={6}>
                    <Card className="h-100">
                        <CardBody>
                            <div style={{ height: '100%', minHeight: '400px' }}>
                                <ReadOnlyMap geometry={jobGeometry} path={pathGeometry} />
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col xl={3} sx={6}>
                    <Card className="h-100">
                        <CardBody>
                            <InfoField
                                title="Machine Operated"
                                value={data?.machineNumber}
                            />
                            <OperatorField
                                operatorFullName={data?.operator?.displayName}
                                operatorId={data?.operatorId}
                                onSubmit={onAssignOperator}
                            />
                            <InfoField
                                title="Start Time"
                                value={data?.startTime}
                                isHour
                            />
                            <InfoField
                                title="End Time"
                                value={data?.endTime}
                                isHour
                            />
                            <InfoField
                                title="Total Hours Worked"
                                value={Number(data?.totalHours?.toFixed(2))}
                            />
                            <InfoField
                                title="Acres Cleared"
                                value={acresCleared}
                            />
                            <JobField
                                jobName={data?.job?.name}
                                jobId={data?.job?.id}
                                onSubmit={onAssignJob}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {(data?.workingSessionNotes?.length || data?.workingSessionImages?.length)
                ? (
                    <Row>
                        <Col>
                            <Card>
                                <CardHeader>
                                    <CardTitle className="font-size-24">Session Details</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <WorkSessionDetails
                                        workingSessionNotes={data?.workingSessionNotes}
                                        workingSessionImages={data?.workingSessionImages}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )
                : null
            }

            <Row>
                <Col xl={12} xs={12}>
                    <Tabs data={data} />
                </Col>
            </Row>

        </Container>
    );
};

export default WorkSessionDetailsContainer;
